import { drawQuestionBox, initQuestionBox } from './../../../Assets/Js/QuestionBoxInline';
import { displayInlineSignupBoxFn, showInlineSignupBoxFn } from './../../../Assets/Js/SignupBoxInline';
// Javascript for LA/Whatsdate
$(document).ready(function () {
	if (drawQuestionBox()) {
		initQuestionBox(function() {
			displayInlineSignupBoxFn();  // show box
		});
		showInlineSignupBoxFn();  // init box (hidden)
	}
});
